import { render } from "./about-us.vue?vue&type=template&id=febafe66"
import script from "./about-us.vue?vue&type=script&lang=js"
export * from "./about-us.vue?vue&type=script&lang=js"

import exportComponent from "D:\\project\\BahteraAdhiguna\\deployment\\ui\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__